import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

const dark_fallback =
  "https://ensinio-public.s3.us-west-1.amazonaws.com/dark_fallback.jpg";
const light_fallback =
  "https://ensinio-public.s3.us-west-1.amazonaws.com/light_fallback.jpg";

export default function getFallbackImage(): string {
  const { state } = useGlobalContext();

  const isDarkMode = state.theme.value === "dark";

  return isDarkMode ? dark_fallback : light_fallback;
}
